export function AuthBody({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex justify-center items-center w-full h-full">
            <div className="flex flex-col items-center w-3/12">{children}</div>
        </div>
    )
}
